import {
  Paper,
  Typography,
  Button,
  TableContainer,
  CircularProgress,
} from "@mui/material";
import TableComponent from "../../component/TableComponent";
import { MouseEvent, useEffect, useState } from "react";
import { useMutation } from "react-query";
import useRepotFile from "../../hooks/reportFileHook";
import {
  monthltInvoiceReportSearch,
  monthlyInvoiceReportPdf,
} from "../services";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
// import { useForm } from "react-hook-form";
const MonthlyInvoiceReport = () => {
  const [selectedDate, setSelected] = useState<{
    from: Dayjs | null;
    to: Dayjs | null;
  }>({
    from: dayjs().startOf("month"),
    to: dayjs().endOf("month"),
  });
  const {
    mutate: getMonthlyInvoiceReport,
    data: invoiceData,
    isLoading: reportLoading,
    reset:resetMutation
  } = useMutation(monthltInvoiceReportSearch);


  const { mutate: getMonthlyInvoiceReportPdf, isLoading: pdfLoading } =
    useRepotFile({
      apiFunction: monthlyInvoiceReportPdf,
      responseFileKey: "file",
    });
  //   const { mutate: getMonthlyRevenueReportExcel, isLoading: excelLoading } =
  //     useRepotFile({
  //       apiFunction: async()=>new Promise(),
  //       fileType: "xls",
  //       responseFileKey: "file",
  //     });

  const fromDateChange = (date: Dayjs | null) => {
    if (date) {
      const day = date.startOf("month");
      setSelected((prev) => ({ ...prev, from: day }));
      if (selectedDate?.to) {
        getMonthlyInvoiceReport({
          fromMonth: day.month() + 1,
          fromYear: parseInt(day.format("YYYY")),
          toMonth:  selectedDate.to.month() + 1,
          toYear: parseInt(selectedDate.to.format("YYYY")),
        });
      }else{
        resetMutation()
      }
    }
  };

  const toDateChange = (date: Dayjs | null) => {
    if (date) {
      const day = date.endOf("month");
      setSelected((prev) => ({ ...prev, to: day }));
      if (selectedDate?.from) {
        getMonthlyInvoiceReport({
          fromMonth: selectedDate.from.month() + 1,
          fromYear: parseInt(selectedDate.from.format("YYYY")),
          toMonth:  day.month() + 1,
          toYear: parseInt(day.format("YYYY")),
        });
      }else{
        resetMutation()
      }
    }
  };

  const clearForm = () => {
    setSelected({ from: null, to: null });
    resetMutation()
  };

  const getFiles = (e: MouseEvent<HTMLButtonElement>) => {
    const fileType = e.currentTarget.dataset.filetype;
    if (selectedDate.from && selectedDate.to) {
      if (fileType === "pdf") {
        getMonthlyInvoiceReportPdf({
          fromMonth: selectedDate.from.month() + 1,
          fromYear: parseInt(selectedDate.from.format("YYYY")),
          toMonth:  selectedDate.to.month() + 1,
          toYear: parseInt(selectedDate.to.format("YYYY")),
        });
      }
    }
  };

  useEffect(() => {
    if (selectedDate.from && selectedDate.to) {
      getMonthlyInvoiceReport({
        fromMonth: selectedDate.from.month() + 1,
        fromYear: parseInt(selectedDate.from.format("YYYY")),
        toMonth:  selectedDate.to.month() + 1,
        toYear: parseInt(selectedDate.to.format("YYYY")),
      });
    }
  }, []);

  return (
    <div className="px-3 py-4 flex flex-col gap-3">
      <Paper>
        <div className="p-4 border-b">
          <Typography color={"primary"} fontWeight={600} fontSize={"1rem"}>
            Monthly Invoice Report
          </Typography>
        </div>
        <div className="grid grid-cols-2 gap-3 p-4">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={selectedDate.from}
              views={["year", "month"]}
              format="MMMM YYYY"
              label="From"
              onChange={fromDateChange}
            />
          </LocalizationProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={selectedDate.to}
              views={["year", "month"]}
              format="MMMM YYYY"
              label="To"
              onChange={toDateChange}
            />
          </LocalizationProvider>
          <div className="col-span-full flex justify-end items-center gap-3">
            {/* <Button
                  type="submit"
                  disabled={reportLoading}
                  endIcon={reportLoading && <CircularProgress size={18} />}
                >
                  search
                </Button> */}
            <Button color="error" onClick={clearForm}>
              clear
            </Button>
          </div>
        </div>
      </Paper>

      <TableContainer component={Paper}>
        <div className="flex justify-end gap-3 py-2 px-4 border-b">
          <Button
            disabled={pdfLoading || !Boolean(invoiceData?.response?.length)}
            endIcon={pdfLoading && <CircularProgress size={18} />}
            data-filetype="pdf"
            onClick={getFiles}
          >
            pdf
          </Button>
          {/* <Button
                disabled={excelLoading || !Boolean(invoiceData?.response?.length)}
                endIcon={excelLoading && <CircularProgress size={18} />}
                data-filetype="excel"
                onClick={getFiles}
              >
                excel
              </Button> */}
        </div>
        <TableComponent
          loading={reportLoading}
          data={invoiceData?.response || []}
          tableProps={heading}
        />
      </TableContainer>
    </div>
  );
};

export default MonthlyInvoiceReport;

const heading = [
  { heading: "Month", key: "monthName" },
  { heading: "Year", key: "year" },
  { heading: "GROSS AMOUNT", key: "totalAmount" },
  { heading: "INS AMOUNT", key: "insShare" },
  { heading: "PAT SHARE", key: "patShare" },
  { heading: "INS DISCOUNT", key: "insDiscount" },
  { heading: "PAT DISCOUNT", key: "patDiscount" },
  { heading: "NET AMOUNT", key: "recivedAmt" },
];
